export default __webpack_public_path__ + "static/partnerColorIcon16-904d02acf2f2a843c7001e527d005304.svg";